import { call, put, takeLatest } from "redux-saga/effects";
import { baoCaoApi } from "../../../api/bao-cao/baoCaoApi";
import { IBaoCaoRequest } from "../../../model/request/bao-cao/IBaoCaoRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eBaoCaoActionTypeIds,
  IBaoCaoActionTypes,
  IBaoCaoBaseActionTypes,
} from "../../action-types/bao-cao/IBaoCaoActionTypes";
// import { saveAs } from "file-saver";
import { rootActions } from "../../actions/rootActions";
import { Download, fileNameWithTime } from "../../../helpers/download";

export function* baoCaoSaga(): any {
  yield takeLatest(eBaoCaoActionTypeIds.LOAD_START, loadWorker);
  yield takeLatest(
    eBaoCaoActionTypeIds.EXPORT_BAO_CAO_START,
    exportExcelWorker,
  );
}

function* loadWorker(action: IBaoCaoActionTypes): any {
  const request = action.payload as IBaoCaoBaseActionTypes<IBaoCaoRequest>;

  const res: IBaseRespone = yield call(baoCaoApi.RenderHtml, request.data);

  if (res.is_success) {
    const data = res.data as string;
    yield put(
      rootActions.baoCao.baoCao.LOAD_SUCCESS({
        selectedTabId: request.selectedTabId,
        data,
      }),
    );
  } else {
    yield put(
      rootActions.baoCao.baoCao.LOAD_ERRR({
        selectedTabId: request.selectedTabId,
        data: res.message ?? "Có lỗi",
      }),
    );
  }
}

function* exportExcelWorker(action: IBaoCaoActionTypes): any {
  const request = action.payload as IBaoCaoBaseActionTypes<IBaoCaoRequest>;
  const res: IBaseRespone = yield call(baoCaoApi.ExportExcel, request.data);
  if (res.is_success) {
    // Tên file = TÊN BÁO CÁO đang xem + ngày giờ (vd "8.2. Bảng tổng hợp khoản thu (gộp học phí) 28-07-2026 1530.xlsx").
    const tenBaoCao = fileNameWithTime(request.data?.bao_cao?.name, "Báo cáo");
    Download.Excel(res.data, `${tenBaoCao}.xlsx`);
    yield put(
      rootActions.baoCao.baoCao.EXPORT_BAO_CAO_SUCCESS({
        selectedTabId: request.selectedTabId,
        data: null,
      }),
    );
  } else {
    yield put(
      rootActions.baoCao.baoCao.EXPORT_BAO_CAO_ERROR({
        selectedTabId: request.selectedTabId,
        data: res.message ?? "Có lỗi",
      }),
    );
  }

  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
}
